import { IconCaretLeft } from '@/components/icons/IconCaretLeft';
import { IconCaretRight } from '@/components/icons/IconCaretRight';
import { VEHICLE_PER_PAGE_OPTIONS, type VehiclePerPage } from './vehicleListing.constants';
import { pageItems, rangeLabel, type VehiclePageState } from './vehiclePagination';
import { VehicleSelect } from './VehicleSelect';

const PER_PAGE_OPTIONS = VEHICLE_PER_PAGE_OPTIONS.map((value) => ({ value, label: String(value) }));

type VehiclePaginationProps = {
    pagination: VehiclePageState;
    total: number;
    perPage: VehiclePerPage;
    onPage: (page: number) => void;
    onPerPage: (perPage: VehiclePerPage) => void;
};

/** Pages, the shown range and the page size. Below md the numbers give way to „Seite 1 von 4“. */
export function VehiclePagination({ pagination, total, perPage, onPage, onPerPage }: VehiclePaginationProps) {
    const { page, pageCount } = pagination;

    return (
        <div className="vehicle-pagination">
            <p className="vehicle-pagination__count text-sm">{rangeLabel(pagination, total)}</p>

            <nav aria-label="Seitennavigation" className="vehicle-pagination__nav">
                <button
                    type="button"
                    className="vehicle-pagination__arrow"
                    aria-label="Vorherige Seite"
                    disabled={page <= 1}
                    onClick={() => onPage(page - 1)}
                >
                    <IconCaretLeft width={16} height={16} aria-hidden="true" />
                </button>

                <ol className="vehicle-pagination__pages">
                    {pageItems(page, pageCount).map((item, index) =>
                        item === 'gap' ? (
                            <li key={`gap-${index}`} className="vehicle-pagination__gap" aria-hidden="true">
                                …
                            </li>
                        ) : (
                            <li key={item}>
                                <button
                                    type="button"
                                    className="vehicle-pagination__page label-sm"
                                    aria-label={`Seite ${item}`}
                                    aria-current={item === page ? 'page' : undefined}
                                    onClick={() => onPage(item)}
                                >
                                    {item}
                                </button>
                            </li>
                        ),
                    )}
                </ol>

                <span className="vehicle-pagination__compact label-sm">
                    Seite {page} von {pageCount}
                </span>

                <button
                    type="button"
                    className="vehicle-pagination__arrow"
                    aria-label="Nächste Seite"
                    disabled={page >= pageCount}
                    onClick={() => onPage(page + 1)}
                >
                    <IconCaretRight width={16} height={16} aria-hidden="true" />
                </button>
            </nav>

            <label className="vehicle-pagination__size">
                <span className="label-sm">Pro Seite</span>
                <VehicleSelect
                    ariaLabel="Fahrzeuge pro Seite"
                    value={perPage}
                    options={PER_PAGE_OPTIONS}
                    onChange={(value) => onPerPage(Number(value) as VehiclePerPage)}
                />
            </label>
        </div>
    );
}
